export const EMPTY_SELECT_VALUE = '';

export const SELECT_LABELS = {
  opcion: 'Seleccioná una opción',
  papelesCompletos: 'Seleccione si tiene papeles completos',
  condicion: 'Seleccioná la condición',
  practica: 'Seleccioná si es práctica',
  extinta: 'Seleccioná si está extinta',
  resultado: 'Seleccioná el resultado',
  carrera: 'Seleccioná la carrera',
  estado: 'Seleccioná el estado'
};

export const YES_NO_OPTIONS = [
  { value: 'S', label: 'Sí' },
  { value: 'N', label: 'No' }
];

export function selectPlaceholder(label = SELECT_LABELS.opcion) {
  return { value: EMPTY_SELECT_VALUE, label };
}

/** Opciones react-select con placeholder como primera fila visible. */
export function withSelectPlaceholder(options, label = SELECT_LABELS.opcion) {
  const items = options.filter((option) => option.value !== EMPTY_SELECT_VALUE);
  return [selectPlaceholder(label), ...items];
}

export function normalizeSelectOptions(options) {
  return (options ?? []).filter((option) => option?.value !== EMPTY_SELECT_VALUE);
}

export function findSelectOptionByValue(options, value) {
  const raw = String(value ?? '').trim();
  return normalizeSelectOptions(options).find(
    (option) => String(option.value).trim() === raw
  ) ?? null;
}

export function findSelectOptionByLabel(options, label) {
  const raw = String(label ?? '').trim();
  return normalizeSelectOptions(options).find((option) => {
    const optionLabel = String(option.label).trim();
    return optionLabel === raw || (raw === 'Si' && optionLabel === 'Sí');
  }) ?? null;
}

export function getSelectOptionValue(option, fallback = '') {
  if (!option) {
    return fallback;
  }
  if (Array.isArray(option)) {
    return option[0]?.value ?? fallback;
  }
  return option.value ?? fallback;
}
